import Vue from 'vue'
import http from './assets/functions/axiosServer'
import htmlToPdf from './assets/functions/htmlToPdf'
import App from './commonApp.vue'
import router from './router'
//import 'element-ui/lib/theme-chalk/index.css'
// 引入自定义主题
import echarts from 'echarts'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import dateMoment from 'moment'
import Qs from 'qs'
import VueClipboard from 'vue-clipboard2'
import VueI18n from "vue-i18n"
import './assets/css/common.css'
// import './assets/css/theme/index.css'
Vue.config.productionTip = false
Vue.prototype.$http=http;
Vue.prototype.$moment=dateMoment
Vue.prototype.$echarts=echarts
Vue.prototype.$qs=Qs
Vue.use(Element)
Vue.use(VueClipboard)
Vue.use(VueI18n)
Vue.use(htmlToPdf)
const i18n=new VueI18n({
    locale: localStorage.aqbCofeLang || 'zh-CN',
    messages: {
        'zh-CN': require('./assets/i18n/zh'),   // 中文语言包
        'en-US': require('./assets/i18n/en')    // 英文语言包
    },
    silentTranslationWarn: true
})
new Vue({
    el:'#app',
    i18n,
    router,
    render: h => h(App)
})
